import Typography from '@/common/components/base/typography/Typography';
import { useMemo, useState } from 'react';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { CustomTabsProps } from '../../types/CustomTab.type';

const CustomTabs = ({
  items,
  defaultActiveId,
  className,
  onChange,
  variant = 'compact',
}: CustomTabsProps) => {
  const firstEnabledId =
    items.find((item) => !item.disabled)?.id ?? items[0]?.id;

  const [activeId, setActiveId] = useState(defaultActiveId || firstEnabledId);

  const activeContent = useMemo(() => {
    return items.find((item) => item.id === activeId)?.content ?? null;
  }, [activeId, items]);

  const handleTabClick = (id: string, disabled?: boolean) => {
    if (disabled) return;
    setActiveId(id);
    onChange?.(id);
  };

  if (!items.length) return null;

  return (
    <Box width="100%" className={className}>
      <Box
        display="flex"
        alignItems="center"
        width={variant === 'full' ? '100%' : 'fit-content'}
        alignSelf={variant === 'full' ? 'stretch' : 'flex-end'}
        gap="8px"
        backgroundColor="gray-3"
        borderRadius="8px"
        padding="6px"
        overflowX="auto"
      >
        {items.map((item) => {
          const isActive = item.id === activeId;

          return (
            <Typography
              key={item.id}
              onClick={() => handleTabClick(item.id, item.disabled)}
              className={css({
                flex: variant === 'full' ? '1' : '0 0 auto',
                minWidth: 'max-content',
                minHeight: '40px',
                padding: '0 8px',
                borderRadius: '8px',
                border: 'none',
                fontSize: '13px',
                transition: 'all 0.2s ease',
                cursor: item.disabled ? 'not-allowed' : 'pointer',
                opacity: item.disabled ? 0.5 : 1,
                backgroundColor: isActive ? 'white' : 'transparent',
                color: isActive ? 'black' : 'black-2',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              })}
            >
              {item.label}
            </Typography>
          );
        })}
      </Box>

      <Box marginTop="16px">{activeContent}</Box>
    </Box>
  );
};

export default CustomTabs;
